import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../../public/environments/environment';
import { Params } from '../interface/core.interface';
import { ICurrencyModel } from '../interface/currency.interface';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  private http = inject(HttpClient);

  getCurrencies(payload?: Params): Observable<ICurrencyModel> {
    //console.log('Fetching currencies with payload:', `${environment.URL}/currency.json`, { params: payload });
    return this.http.get<ICurrencyModel>(`${environment.URL}/currency.json`, { params: payload });
  }
}
